import api from "@/utils/api"

const defaultList = {
	current_page: 1,
	detail: [],
	is_gather: 0,
	is_release: 0,
	total_count: 0,
	total_page: 0
}
const exam = {
	namespaced: true,           // 命名空间
	state: {
		examList: [],
		phInfo:{},
		myScore:{},
		isPC:true,
	},
	mutations: {
		SET_EXAM_LIST: (state, value) => {
			state.examList = value
		},
		SET_PH_LIST: (state, value) => {
			state.phInfo= value.detail;
			if(value.my_score){
				state.myScore = value.my_score;
			}
		},
		SET_PC_STATE: (state, value)=>{
			state.isPC = value
		}
	},
	actions: {
		getExamList({ commit }, param) {
			return new Promise((resolve, reject) => {
				api.getExamList(param).then(resp => {
					if (resp && resp.status.state == 1000) {
						commit('SET_EXAM_LIST', resp.content)
					}
					resolve(resp)
				}).catch(err => {
					reject(err)
				})
			})
		},
		getphInfo({ commit }, param) {
			return new Promise((resolve, reject) => {
				api.getphInfo(param).then(resp => {
					if (resp && resp.status.state == 1000) {
            console.log(",,,,,,,,,,,,,,,",resp.content)
						commit('SET_PH_LIST', resp.content)
					}
					resolve(resp)
				}).catch(err => {
					reject(err)
				})
			})
		},
		startExam({ commit }, param) {
			return new Promise((resolve, reject) => {
				api.startExam(param).then(resp => {
					resolve(resp)
				}).catch(err => {
					reject(err)
				})
			})
		},
		submitInfo({ commit }, param) {
			return new Promise((resolve, reject) => {
				api.addlilun(param).then(resp => {
					resolve(resp)
				}).catch(err => {
					reject(err)
				})
			})
		},
		examEnd({ commit }, param) {
			return new Promise((resolve, reject) => {
				api.examEnd(param).then(resp => {
					resolve(resp)
				}).catch(err => {
					reject(err)
				})
			})
		},
	},
	getters: {
		examList: (state) => {
			return state.examList
		},
		phInfo: (state) => {
      		console.log("getters...............",state.phInfo)
			return state.phInfo
		},
		myScore: (state) => {
			return state.myScore
		},
		isPC: (state) => {
			return state.isPC
		},
	}
}
export default exam;



// WEBPACK FOOTER //
// ./src/store/modules/rank.js